const creditHeaders = [
  {
    key: 'operationDate',
    label: 'Fecha operación',
    type: 'date',
  },
  { key: 'requestType', label: 'Tipo' },
  { key: 'operationId', label: 'Id Solicitud', type: 'numeric-id' },
  { key: 'documentType', label: 'Tipo documento' },
  { key: 'businessIdentifier', label: 'RUT cliente' },
  { key: 'businessName', label: 'Nombre cliente' },
  { key: 'amount', label: 'Monto operación', type: 'money' },
  {
    key: 'priceDifference',
    label: 'Diferencia de precio',
    type: 'money',
  },
  { key: 'commissionAmount', label: 'Monto comisión', type: 'money' },
  { key: 'comissionIVA', label: 'IVA comisión', type: 'money' },
  { key: 'expensesCost', label: 'Gastos', type: 'money' },
  { key: 'expensesCostIVA', label: 'IVA gastos', type: 'money' },
  {
    key: 'documentsAmount',
    label: 'Aplica documentos',
    type: 'money',
  },
  { key: 'amountRemaining', label: 'Monto restante', type: 'money' },
  { key: 'remittedAmount', label: 'Total giro', type: 'money' },
  { key: 'advancePercentage', label: 'Porcentaje anticipado' },
  { key: 'interestRate', label: 'Tasa negociada' },
  { key: 'arrearRate', label: 'Tasa mora' },
  { key: 'executive', label: 'Ejecutivo' },
];

export default creditHeaders;
